import { Grid } from '@material-ui/core';
import { Autocomplete,  Box,  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, LinearProgress, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import SaveIcon from '@mui/icons-material/Save';
import LocalisationMisService from '../../../services/LocalisationMisService';
import { LoadingButton } from '@mui/lab';
import KilometersMissionService from '../../../services/KilometersMissionService';
import MissionTransportService from '../../../services/MissionTransportService';
import MadagascarMap from '../../../components/MadagascarMap';
import TimeSheetMissionService from '../../../services/TimeSheetMissionService';

const bullRed = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '5px', transform: 'scale(0.8)', color: 'red', fontSize: '20px' }}
  >
    *
  </Box>
)

const DestinationDriverDialog = (props) => {
    const { destDialog, setDestDialog, setMessage, fetchDestinations } = props;
    const { open, agenda_id, mission_timesheet_id, onClose, missionnaries, mode, destination, transport_id } = destDialog;
    const isEdit = mode === 'edit' && destination;
    const initFormValues = {
        action: 'create',
        type : '',
        date_begin : '',
        date_end : '',
        heure_begin : '',
        heure_end : '',
        region_depart : '',
        district_depart : '',
        commune_depart : '',
        region_arrivee : '',
        district_arrivee : '',
        commune_arrivee : '',
        lieu_depart : '',
        lieu_arrivee : '',
        observation : '',
        mission_planning_agenda_id : agenda_id,
        mission_timesheet_id : mission_timesheet_id,
        transport_id: transport_id || '',
        mission_timesheet_destination_id: null,
        is_driver: 1,
        type: "DR",
    }
    const [formvalues, setFormvalues] = useState(initFormValues);
    const [regions, setRegions] = useState([]);
    const [districtsDepart, setDistrictsDepart] = useState([]);
    const [districtsArrivee, setDistrictsArrivee] = useState([]);
    const [communesDepart, setCommunesDepart] = useState([]);
    const [communesArrivee, setCommunesArrivee] = useState([]);
    const [geodata, setGeodata] = useState({});
    const [loading, setLoading] = useState({
        region_arrivee: false,
        region_depart: false,
        district_arrivee: false,
        district_depart: false,
        commune_arrivee: false,
        commune_depart: false,
        submit: false,
    });
    const [transport, setTransport] = useState([]);

    const resolveOption = (value, options, labelKey, idKey) => {
        if (!value) {
            return null;
        }
        if (typeof value === 'object') {
            return value;
        }
        return (
            (options || []).find(
                (option) =>
                    (idKey && String(option[idKey]) === String(value)) ||
                    (labelKey && option[labelKey] === value)
            ) || null
        );
    };

    const getOptionLabelValue = (value, labelKey) => {
        if (!value) {
            return '';
        }
        if (typeof value === 'object') {
            return value[labelKey] || '';
        }
        return value;
    };

   useEffect(() => {
       const fetchRegions = async () => {
        try {
            setLoading((prev) => ({ ...prev, region_depart: true, region_arrivee: true }));
            const regionsResult = await LocalisationMisService.getRegions();
            if(regionsResult.status){
                setRegions(regionsResult.data);
                setLoading((prev) => ({ ...prev, region_depart: false, region_arrivee: false }) );
            }
        } catch (error) {
            console.error("Error fetching regions:", error);
        }
       }

       const fetchTransport = async () => {
        try {
            const transportResult = await MissionTransportService.transportationMode();
            if(transportResult.status){
                setTransport(transportResult.data);
            }
        } catch (error) {
            console.error("Error fetching transport:", error);
        }
       };

         if (open && agenda_id) {
            setFormvalues((prev) => ({ ...prev, 
            mission_planning_agenda_id: agenda_id,
            mission_timesheet_id: mission_timesheet_id,
            transport_id: transport_id || prev.transport_id || '',
            is_driver: 1}));
            fetchRegions();
            fetchTransport();
        }
    }, [open, agenda_id, mission_timesheet_id, transport_id]);

    useEffect(() => {
        if (!open) {
            return;
        }

        if (isEdit && destination) {
            setFormvalues({
                ...initFormValues,
                action: 'update',
                mission_timesheet_destination_id: destination.mission_timesheet_destination_id || null,
                type: destination.type || initFormValues.type,
                transport_id: destination.transport_id || initFormValues.transport_id || '',
                date_begin: destination.date_begin || '',
                date_end: destination.date_end || '',
                heure_begin: destination.heure_begin || '',
                heure_end: destination.heure_end || '',
                region_depart: destination.region_depart || '',
                district_depart: destination.district_depart || '',
                commune_depart: destination.commune_depart || '',
                region_arrivee: destination.region_arrivee || '',
                district_arrivee: destination.district_arrivee || '',
                commune_arrivee: destination.commune_arrivee || '',
                lieu_depart: destination.lieu_depart || '',
                lieu_arrivee: destination.lieu_arrivee || '',
                observation: destination.observation || '',
            });
        } else {
            setFormvalues(initFormValues);
        }
    }, [
        open,
        isEdit,
        destination?.mission_timesheet_destination_id,
        destination?.mission_destination_id,
        agenda_id,
        mission_timesheet_id,
        transport_id
    ]);

     const loadDistrictsByRegion = async (regionId, type = "depart") => {
        if (!regionId) {
            return;
        }
        const setDistricts = type === "depart" ? setDistrictsDepart : setDistrictsArrivee;
        const district = type === "depart" ? "district_depart" : "district_arrivee";
        try {
            setLoading((prev) => ({ ...prev, [district]: true }));
            const districtsResult = await LocalisationMisService.getDistrictByRegion(regionId);
            if(districtsResult.status){
                setDistricts(districtsResult.data);
            } else {
                setDistricts([]);
            }
        } catch (error) {
            console.error("Error fetching districts:", error);
            setDistricts([]);
        } finally {
            setLoading((prev) => ({ ...prev, [district]: false }));
        }
     };

     const loadCommunesByDistrict = async (districtId, type = "depart") => {
        if (!districtId) {
            return;
        }
        const commune = type === "depart" ? "commune_depart" : "commune_arrivee";
        const setCommunes = type === "depart" ? setCommunesDepart : setCommunesArrivee;
        try {
            setLoading((prev) => ({ ...prev, [commune]: true }));
            const communesResult = await LocalisationMisService.getCommunesByDistrict(districtId);
            if(communesResult.status){
                setCommunes(communesResult.data);
            } else {
                setCommunes([]);
            }
        } catch (error) {
            console.error("Error fetching communes:", error);
            setCommunes([]);
        } finally {
            setLoading((prev) => ({ ...prev, [commune]: false }));
        }
     };

     const handleChangeRegion = async (e, value, type = "depart") => {
        const name = type === "depart" ? "region_depart" : "region_arrivee";
        const district = type === "depart" ? "district_depart" : "district_arrivee";
        const commune = type === "depart" ? "commune_depart" : "commune_arrivee";
        const setDistricts = type === "depart" ? setDistrictsDepart : setDistrictsArrivee;
        const setCommunes = type === "depart" ? setCommunesDepart : setCommunesArrivee;
        setFormvalues((prev) => ({ ...prev, [name]: value, [district]: '', [commune]: '' }));
        setDistricts([]);
        setCommunes([]);
        if (!value?.id_region) {
            return;
        }
        await loadDistrictsByRegion(value.id_region, type);
    }
    const handleChangeDistrict = async (e, value, type = "depart") => {
        const name = type === "depart" ? "district_depart" : "district_arrivee";
        const commune = type === "depart" ? "commune_depart" : "commune_arrivee";
        const setCommunes = type === "depart" ? setCommunesDepart : setCommunesArrivee;
        setFormvalues((prev) => ({ ...prev, [name]: value, [commune]: '' }));
        setCommunes([]);
        if (!value?.id_district) {
            return;
        }
        await loadCommunesByDistrict(value.id_district, type);
    }
    const handleChangeCommune = (e, value, type = "depart") => {
        const name = type === "depart" ? "commune_depart" : "commune_arrivee";
        setFormvalues((prev) => ({ ...prev, [name]: value }));
    }

    const regionDepartValue = resolveOption(formvalues.region_depart, regions, 'nom_region', 'id_region');
    const regionArriveeValue = resolveOption(formvalues.region_arrivee, regions, 'nom_region', 'id_region');
    const districtDepartValue = resolveOption(formvalues.district_depart, districtsDepart, 'nom_district', 'id_district');
    const districtArriveeValue = resolveOption(formvalues.district_arrivee, districtsArrivee, 'nom_district', 'id_district');
    const communeDepartValue = resolveOption(formvalues.commune_depart, communesDepart, 'nom_commune', 'id_commune');
    const communeArriveeValue = resolveOption(formvalues.commune_arrivee, communesArrivee, 'nom_commune', 'id_commune');

    useEffect(() => {
        if (!open || !regionDepartValue?.id_region) {
            return;
        }
        loadDistrictsByRegion(regionDepartValue.id_region, "depart");
    }, [open, regionDepartValue?.id_region]);

    useEffect(() => {
        if (!open || !regionArriveeValue?.id_region) {
            return;
        }
        loadDistrictsByRegion(regionArriveeValue.id_region, "arrivee");
    }, [open, regionArriveeValue?.id_region]);

    useEffect(() => {
        if (!open || !districtDepartValue?.id_district) {
            return;
        }
        loadCommunesByDistrict(districtDepartValue.id_district, "depart");
    }, [open, districtDepartValue?.id_district]);

    useEffect(() => {
        if (!open || !districtArriveeValue?.id_district) {
            return;
        }
        loadCommunesByDistrict(districtArriveeValue.id_district, "arrivee");
    }, [open, districtArriveeValue?.id_district]);

    const verifyForm = () => {
        if(!formvalues.date_begin || !formvalues.date_end || !formvalues.heure_begin || !formvalues.heure_end || !formvalues.region_depart || !formvalues.region_arrivee){
            return false;
        }
        return true;
    }

    const handleSubmit = async () => {

        if(!verifyForm()){
            setMessage({ open: true, color: 'red', messageInfo: "Veuillez remplir tous les champs obligatoires" });
            return;
        }
        
       const dataTosend = {
        ...formvalues,
        region_depart: getOptionLabelValue(formvalues.region_depart, 'nom_region'),
        district_depart: getOptionLabelValue(formvalues.district_depart, 'nom_district'),
        commune_depart: getOptionLabelValue(formvalues.commune_depart, 'nom_commune'),
        region_arrivee: getOptionLabelValue(formvalues.region_arrivee, 'nom_region'),
        district_arrivee: getOptionLabelValue(formvalues.district_arrivee, 'nom_district'),
        commune_arrivee: getOptionLabelValue(formvalues.commune_arrivee, 'nom_commune'),
       }

         try {
          const response = await TimeSheetMissionService.addOrUpdateDestination(dataTosend);
            // const response = await KilometersMissionService.addDestinationKilometerMission(dataTosend);
            if (response.status) {
                setMessage({ open: true, color: 'green', messageInfo: isEdit ? "Destination modifiée avec succès" : "Destination ajoutée avec succès" });
                if (!isEdit) {
                    setFormvalues(initFormValues);
                }
                onClose();
                fetchDestinations(agenda_id);
            }
        } catch (error) {
            setMessage({ open: true, color: 'red', messageInfo: isEdit ? "Erreur lors de la modification de la destination" : "Erreur lors de l'ajout de la destination" });
            console.error("Error creating mission:", error);
        }
    }

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle  id="form-dialog-title" style={{ color: "white" }}>
                {isEdit ? "Modifier la destination" : "Ajouter une nouvelle destination"}
            </DialogTitle>
            <DialogContent dividers>
               <DialogContentText>
                <Grid container spacing={2}>

                <Grid container item sx={12} md={12} xl={12} spacing={2} marginTop={1}>
                <Grid item xs={12} sm={6} md={6}>
                    <FormControl fullWidth>
                        <label>Date de départ {bullRed}</label>
                        <TextField variant="outlined" fullWidth size='small' type='date'
                        value={formvalues.date_begin || ''}
                        onChange={(e) => setFormvalues({ ...formvalues, date_begin : e.target.value })}
                        />
                    </FormControl>
                    
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                    <FormControl fullWidth>
                        <label>Date d'arrivé {bullRed}</label>
                        <TextField variant="outlined" fullWidth  size='small' type='date'
                        value={formvalues.date_end || ''}
                        onChange={(e) => setFormvalues({ ...formvalues, date_end : e.target.value })}
                        />
                    </FormControl>
                    
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                    <FormControl fullWidth>
                        <label>Heure de départ {bullRed}</label>
                          <TextField
                                      fullWidth
                                      type="time"
                                      variant="outlined"      
                                      InputLabelProps={{
                                          shrink: true,
                                      }}
                                      value={formvalues.heure_begin || ''}
                                      onChange={(e) => setFormvalues({ ...formvalues, heure_begin : e.target.value })}
                                      size='small'
                                      inputProps={{
                                          'aria-label': 'Heure de départ'
                                      }}
                                  />
                    </FormControl>
                    
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                    <FormControl fullWidth>
                        <label>Heure d'arrivé {bullRed}</label>
                          <TextField
                                      fullWidth
                                      type="time"
                                      variant="outlined"
                                      InputLabelProps={{
                                          shrink: true,
                                      }}
                                      value={formvalues.heure_end || ''}
                                      onChange={(e) => setFormvalues({ ...formvalues, heure_end : e.target.value })}
                                      size='small'
                                      inputProps={{
                                          'aria-label': 'Heure d\'arrivée'
                                      }}
                                  />
                    </FormControl>
                    
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                    <FormControl fullWidth>
                        <label>Lieu de départ {bullRed}</label>
                        {
                            loading.region_depart && <LinearProgress />
                        }
                           <Autocomplete
                            fullWidth
                            disablePortal
                            size="small"
                            options={regions || []}
                            sx={{ mb: 1 }}
                            disabled={loading.region_depart}
                            value={regionDepartValue}
                            onChange={(e, value) => handleChangeRegion(e, value, "depart")}
                            getOptionLabel={(option) => option.nom_region || ""}
                            isOptionEqualToValue={(option, value) => option.id_region === value.id_region} 
                            renderInput={(params) => (
                                <TextField {...params} label={`Région`} variant="outlined" />
                            )}
                            />
                            {
                                loading.district_depart && <LinearProgress />
                            }
                         <Autocomplete
                            fullWidth
                            disablePortal
                            size='small'
                            disabled={loading.district_depart}
                            value={districtDepartValue}
                            options={districtsDepart || []}
                            onChange={(e, value) => handleChangeDistrict(e, value, "depart")}
                            sx={{ mb: 1 }}
                            getOptionLabel={(option) => option.nom_district || ""}
                            renderInput={(params) => <TextField {...params} label={`District`} variant="outlined" />}
                        />
                            {
                                loading.commune_depart && <LinearProgress />
                            }
                         <Autocomplete
                            fullWidth
                            disablePortal
                            size='small'
                            options={communesDepart || []}
                            disabled={loading.commune_depart}
                            value={communeDepartValue}
                            sx={{ mb: 1 }}
                            getOptionLabel={(option) => option.nom_commune || ""}
                            onChange={(e, value) => handleChangeCommune(e, value, "depart")}
                            renderInput={(params) => <TextField {...params} label="Commune" variant="outlined" />}
                        />

                    </FormControl>
                    
                </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <FormControl fullWidth>
                        <label>Lieu d'arrivé {bullRed}</label>
                        {
                            loading.region_arrivee && <LinearProgress />
                        }
                            <Autocomplete
                            fullWidth
                            disablePortal
                            disabled={loading.region_arrivee}
                            value={regionArriveeValue}
                            size="small"
                            options={regions || []}
                            onChange={(e, value) => handleChangeRegion(e, value, "arrivee")}
                            sx={{ mb: 1 }}
                            getOptionLabel={(option) => option.nom_region || ""}
                            isOptionEqualToValue={(option, value) => option.id_region === value.id_region} 
                            renderInput={(params) => (
                                <TextField {...params} label={`Région`} variant="outlined" />
                            )}
                            />
                            {
                                loading.district_arrivee && <LinearProgress />
                            }
                         <Autocomplete
                            fullWidth
                            disablePortal
                            disabled={loading.district_arrivee}
                            value={districtArriveeValue}
                            size='small'
                            options={districtsArrivee || []}
                            getOptionLabel={(option) => option.nom_district || ""}
                            onChange={(e, value) => handleChangeDistrict(e, value, "arrivee")}
                            sx={{ mb: 1 }}
                            renderInput={(params) => <TextField {...params} label={`District`} variant="outlined" />}
                        />
                            {
                                loading.commune_arrivee && <LinearProgress />
                            }
                         <Autocomplete
                            fullWidth
                            disablePortal
                            size='small'
                            disabled={loading.commune_arrivee}
                            value={communeArriveeValue}
                            options={communesArrivee || []}
                            getOptionLabel={(option) => option.nom_commune || ""}
                            onChange={(e, value) => handleChangeCommune(e, value, "arrivee")}
                            sx={{ mb: 1 }}
                            renderInput={(params) => <TextField {...params} label="Commune" variant="outlined" />}
                        />
                    </FormControl>
                    
                </Grid>
                 
                 <Grid item xs={12} sm={6} md={6}>
                    <FormControl fullWidth>
                        <label>Départ</label>
                        <TextField label="Départ" variant="outlined" fullWidth size='small' value={formvalues.lieu_depart || ''} onChange={(e) => setFormvalues({ ...formvalues, lieu_depart: e.target.value })} />
                    </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                    <FormControl fullWidth>
                        <label>Vers</label>
                        <TextField label="Vers" variant="outlined" fullWidth size='small' value={formvalues.lieu_arrivee || ''} onChange={(e) => setFormvalues({ ...formvalues, lieu_arrivee: e.target.value })} />
                    </FormControl>
                    </Grid>
                </Grid>
                </Grid>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
             <span style={{color: "red", marginRight: "24vw"}} > {bullRed} indique un champ obligatoire</span>  
                <Button onClick={() => {onClose()}} color="error" variant='outlined'>
                    Annuler
                </Button>
                <Button   loading={loading.submit} disabled={loading.submit} loadingPosition="end" startIcon={<SaveIcon />} onClick={handleSubmit} color="info" variant='contained' autoFocus>
                    Enregistrer
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default DestinationDriverDialog;
